import React from 'react';
import './blog.css';
import blogImage from "../../assets/images/cellcash/3.jpg";
import { NavLink, useNavigate, useLocation } from "react-router-dom"

const Blogs = () => {
    const blogs = [
        {
            id: 12,
            title: "Cash for Old Phones: Why Mobile Buyback Booms in India!",
            bimage: "https://api.cellcash.net/assets/thumbnails/blogs/mobile-buyback.png",
            url: "/sell-your-old-phone-online",
            dateTime: "17 June 2025",
            profileImage: "images/profile/mobile-buyback-sell-old-phones.jpg",
            details: "In the fast-paced Indian smartphone market, technology is evolving faster than ever. Every few months, a new phone enters the market with upgraded features, better ",

        },
        {
            id: 13,
            title: "Turn Old Into Gold: Repurposing Your Old Smartphones",
            bimage: "https://api.cellcash.net/assets/thumbnails/blogs/sell-repurpose-old-smartphones.png",
            url: "/sell-your-smartphone-online",
            dateTime: "16 June 2025",
            profileImage: "images/profile/sell-repurpose-old-smartphones.jpg",
            details: "Do you have an old smartphone lying around collecting dust? You're not alone. Most people upgrade to new devices every 2-3 years,",

        },
        {
            id: 14,
            title: "Android Phone Resale: Best Time and Places to Sell for Cash",
            bimage: "https://api.cellcash.net/assets/thumbnails/blogs/android-phone-resale.png",
            url: "/sell-your-used-android-phone",
            dateTime: "15 June 2025",
            profileImage: "images/profile/sell-repurpose-old-smartphones.jpg",
            details: "Upgrading to a new Android device is exciting — but what happens to the old one? It usually ends up forgotten in a drawer,",

        }
        ,
        {
            id: 15,
            title: "Online vs Offline: Where Should You Sell Your Android Phone for Best Price?",
            bimage: "https://api.cellcash.net/assets/thumbnails/blogs/online-vs-offline-phone-resale.png",
            url: "/sell-your-android-phone-for-best-price",
            dateTime: "14 June 2025",
            profileImage: "images/profile/sell-repurpose-old-smartphones.jpg",
            details: "Selling your smartphone is no longer just about walking into a store and asking, “How much can I get for this?” In today’s",

        }
        ,
        {
            id: 16,
            title: "Avoid Phone Resale Scams: What Every Seller Must Know in 2025",
            bimage: "https://api.cellcash.net/assets/thumbnails/blogs/avoid-phone-resale-scams-2025.png",
            url: "/best-phone-sale-online-platform-2025",
            dateTime: "13 June 2025",
            profileImage: "images/profile/sell-repurpose-old-smartphones.jpg",
            details: "In today’s digital-first world, selling your old smartphone online has never been easier—or riskier. As platforms for second-hand mobile sales grow,",

        }
        ,
        {
            id: 6,
            title: "iPhone vs Android: Which Phones Sell Faster for Cash in Hyderabad?",
            bimage: "https://api.cellcash.net/assets/thumbnails/blogs/iPhone-vs-android.png",
            url: "/instant-cash-for-mobile-hyderabad",
            dateTime: "10 May 2025",
            profileImage: "images/profile/worried-about-scams.jpg",
            details: "In the bustling tech-oriented city of Hyderabad, cashing in on old smartphones has become a trend. Whether you are",

        },
        {
            id: 7,
            title: "How to Spot Fake Mobile Phones While Shopping Online in Hyderabad",
            bimage: "https://api.cellcash.net/assets/thumbnails/blogs/how-to-spot-fake-mobile-phones-while-shopping-online-in-hyderabad.png",
            url: "/spot-fake-mobile-phones-online-hyderabad",
            dateTime: "09 May 2025",
            profileImage: "images/profile/worried-about-scams.jpg",
            details: "In the bustling tech-oriented city of Hyderabad, cashing in on old smartphones has become a trend. Whether you are upgrading to the new model ",

        },
        {
            id: 8,
            title: "How to Safely Sell Old Gadgets and Protect Your Data",
            bimage: "https://api.cellcash.net/assets/thumbnails/blogs/how-to-safely-sell-old-gadgets-and-protect-your-data.png",
            url: "/how-to-safely-sell-old-gadgets-and-protect-your-data",
            dateTime: "08 May 2025",
            profileImage: "images/profile/worried-about-scams.jpg",
            details: "Selling old gadgets in Hyderabad is a great way to earn extra cash, but it's important to follow certain steps to protect your personal data. ",

        },
        ,
        {
            id: 9,
            title: "How to Check Your Phone's Resale Value Before Selling in Hyderabad",
            bimage: "https://api.cellcash.net/assets/thumbnails/blogs/how-to-check-your-phones-resale-value-before-selling-in-hyderabad.png",
            url: "/how-to-check-your-phone-resale-value-in-hyderabad",
            dateTime: "07 May 2025",
            profileImage: "images/profile/worried-about-scams.jpg",
            details: "Thinking of upgrading to a newer phone? Before you toss your current one aside, make sure you’re not leaving money on the table.  ",

        },
        {
            id: 10,
            title: "Is It Safe to Sell Phones Online? Here's How CellCash Protects You",
            bimage: "https://api.cellcash.net/assets/thumbnails/blogs/is-it-safe-to-sell-phones-online-heres-how-cellcash-protects-you.png",
            url: "/is-it-safe-to-sell-phones-online",
            dateTime: "06 May 2025",
            profileImage: "images/profile/handsome-asian-man-listening-music-through-headphones.jpg",
            details: "In the era of online marketplaces, many individuals are opting to sell their mobile phones online in Hyderabad, thanks to the convenience and quick process it offers.",

        },
        {
            id: 11,
            title: "Worried About Scams? Here’s How CellCash Guarantees a Safe Selling Experience",
            bimage: "https://api.cellcash.net/assets/thumbnails/blogs/worried-about-scams.png",
            url: "/sell-phone-online-hyderabad-safe-cellcash",
            dateTime: "05 May 2025",
            profileImage: "images/profile/worried-about-scams.jpg",
            details: "Are you looking to sell phone online in Hyderabad but constantly worrying about scams and unreliable buyers? You're not alone. With the rise of online marketplaces,",

        },


        {
            id: 5,
            title: "Sell Your Old Phone for Cash: The Best Ways to Get Instant Money",
            bimage: "https://api.cellcash.net/assets/thumbnails/blogs/sell-your-old-phone-for-cash.png",
            url: "/sell-your-old-phone-for-cash",
            dateTime: "16 Mar 2025",
            profileImage: "images/profile/handsome-asian-man-listening-music-through-headphones.jpg",
            details: "Are you holding onto an old phone that you no longer use? Instead of letting it gather dust, why not turn it into instant cash?",

        },

        {
            id: 4,
            title: "Hyderabad's Top Cashify Alternatives for Quick Cash Deals",
            bimage: "https://api.cellcash.net/assets/thumbnails/blogs/hyderabad-cashify-alternatives-quick-cash-deals.png",
            url: "/hyderabad-cashify-alternatives-quick-cash-deals",
            dateTime: "15 Mar 2025",
            profileImage: "images/profile/handsome-asian-man-listening-music-through-headphones.jpg",
            details: "If you're looking for quick cash deals in Hyderabad, you may have already heard of Cashify, a popular platform for selling used electronics.",

        },
        {
            id: 3,
            title: "The Growing Market for Used Phones in Hyderabad",
            bimage: "https://api.cellcash.net/assets/thumbnails/blogs/the-growing-market-for-used-phones-in-hyderabad.png",
            url: "/sell-used-phone-hyderabad",
            dateTime: "14 Mar 2025",
            profileImage: "images/profile/handsome-asian-man-listening-music-through-headphones.jpg",
            details: "Your old smartphone is more valuable than you think. Rather than letting it gather dust in a dusty drawer, why not sell a used mobile in Hyderabad",

        },
        {
            id: 2,
            title: "Why Apple iPhones Have a Higher Resale Value Than Android Phones",
            bimage: "https://api.cellcash.net/assets/thumbnails/blogs/why-apple-iphones-have-higher-resale-value-than-android.png",
            url: "/why-apple-iphones-have-higher-resale-value-than-android",
            dateTime: "13 Mar 2025",
            profileImage: "images/profile/cute-smiling-woman-outdoor-portrait.jpg",
            details: "In the rapidly expanding smartphone industry, one undeniable truth is – Apple iPhones retain their resale value significantly",

        },
        {
            id: 1,
            title: "Everything You Need to Know About Selling Your Old Phone for the Best",
            bimage: "https://api.cellcash.net/assets/thumbnails/blogs/sell-old-phone-best-price-2025.png",
            url: "/sell-old-phone-best-price-2025",
            dateTime: "12 Mar 2025",
            profileImage: "images/profile/woman-posing-black-dress-medium-shot.jpg",
            details: "As technology is advancing rapidly in mobile devices, most individuals are replacing their smartphones more often than before.",

        },

    ];

    return (
        <section className="related-podcast-section section-padding">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12 col-12">
                        <div className="section-title-wrap mb-5">
                            <h4 className="section-title">Blogs</h4>
                        </div>
                    </div>

                    {blogs.map((blog) => (
                        <div className="col-lg-4 col-12 mb-4" key={blog.id}>
                            <div className="custom-block custom-block-full p-30">
                                <div className="custom-block-image-wrap">
                                    <NavLink to={blog.url}>
                                        <img src={blog.bimage} className="custom-block-image img-fluid" alt={blog.title} />
                                    </NavLink>
                                </div>

                                <div className="custom-block-info">
                                    <div className="custom-block-top d-flex mb-1">
                                        <small >
                                            <i className="bi-clock-fill custom-icon me-1"></i>
                                            {blog.dateTime}
                                        </small>
                                    </div>
                                    <div className="mb-2">
                                        <h2 className='font-20'> <NavLink to={blog.url}>{blog.title}</NavLink></h2>
                                    </div>



                                    <p className="mb-0">{blog.details}</p>

                                    <div className="custom-block-bottom d-flex justify-content-between mt-3">

                                    </div>
                                </div>


                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Blogs;
